import React, { useEffect } from "react";
import { Box, Typography, Button } from "@mui/material";
import CheckCircleIcon from "@mui/icons-material/CheckCircle";
import { useNavigate } from "react-router-dom";
import Header from "../Header";
import Footer from "../Footer";

const ThankYou = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // ✅ Google Ads Conversion Tracking (Cumbum)
    if (window.gtag) {
      window.gtag("event", "conversion", {
        send_to: "AW-16903855981/gQC9CJf_-fEbEO2-sfw-",
        value: 500.0,
        currency: "INR",
      });
    } else {
      console.warn("⚠️ gtag not found — ensure Google tag is loaded in index.html");
    }
  }, []);

  return (
    <div>
      <Header />

      <Box
        sx={{
          minHeight: "70vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          textAlign: "center",
          px: 3,
          py: 8,
        }}
      >
        <Box sx={{ maxWidth: 480 }}>
          <CheckCircleIcon sx={{ fontSize: 72, color: "#16a34a", mb: 2 }} />
          <Typography
            variant="h3"
            fontWeight="bold"
            sx={{ color: "#16a34a", mb: 2, fontSize: { xs: "1.9rem", md: "2.5rem" } }}
          >
            Thank You!
          </Typography>
          <Typography variant="body1" sx={{ color: "#444", mb: 4, fontSize: "1.05rem" }}>
            Your appointment request has been received. Our team will get in
            touch with you shortly to confirm the details.
          </Typography>
          <Button
            variant="contained"
            size="large"
            sx={{
              bgcolor: "#e3242b",
              px: 4,
              py: 1.3,
              fontWeight: "bold",
              borderRadius: "8px",
              "&:hover": { bgcolor: "#c81d15" },
            }}
            onClick={() => navigate("/")}
          >
            Back to Home
          </Button>
        </Box>
      </Box>

      <Footer />
    </div>
  );
};

export default ThankYou;
